export default __webpack_public_path__ + "static/media/Ask-A-Medical-Expert_580x340.4b891086.jpg";